import React, { useContext, useEffect, useState } from 'react';
import {
	Box,
	AppBar,
	Grid,
	Toolbar,
	Typography,
	FormGroup,
	FormControlLabel,
	Switch,
    Button,
} from '@mui/material';
import logo from '../assets/imgs/logo.png';
import logo_hever_eng from '../assets/imgs/Translations_Logo_eng.png';
import { Link } from 'react-router-dom';
import styled from '@emotion/styled';
import AppContext from '../Contexts/AppContext';
import theme from '../Styles/CustomTheme';
import OrderContext from '../Contexts/OrderContext';
import { EditCartService } from '../services/api';
import { handlingAfterFetch } from '../Helpers/Tools';

function Header({ isTransparent }) {
	const {
		setAlertObject,
		currentLanguage,
		setCurrentLanguage,
		systemLanguages,
		isRtl,
		setIsRtl,
		windowWidth,
        basePath, 
        setBasePath
	} = useContext(AppContext);

	const {
		cart,
		setCart,
	} = useContext(OrderContext);

	const header_styles = (isTransparent) => {
        return{
            maxWidth: '100%',
            paddingInline: 'max(4vw, 20px)',
            boxShadow: isTransparent ? 'none' : '0px 0px 50px rgba(0, 0, 0, 0.16)',
            maxHeight: '140px',
            background: isTransparent ? 'transparent' : '#fff',
            pt: isTransparent ? '62px' : '16px',
            pb: isTransparent ? '0' : '16px'
        }
	};

	const MaterialUISwitch = styled(Switch)(({ theme }) => ({
		width: 52,
		height: 28,
		padding: 7,
		'& .MuiSwitch-switchBase': {
			margin: 1,
			padding: 0,
			transform: 'translateX(6px)',
			'&.Mui-checked': {
				transform: 'translateX(22px)',
				'& .MuiSwitch-thumb:before': {
					backgroundColor: theme.palette.primary.main,
				},
				'& + .MuiSwitch-track': {
					opacity: 1,
					backgroundColor: '#aab4be',
				},
			},
		},
		'& .MuiSwitch-thumb': {
			backgroundColor: 'transparent',
			width: 24,
			height: 24,
			'&:before': {
				content: "''",
				position: 'absolute',
				width: '100%',
				height: '100%',
				left: 0,
				top: 0,
				boxShadow: '0px 0px 4px 0px rgba(0,0,0,0.8)',
				borderRadius: '50%',
				backgroundRepeat: 'no-repeat',
				backgroundPosition: 'center',
				backgroundColor: theme.palette.primary.main,
			},
		},
		'& .MuiSwitch-track': {
			opacity: 1,
			backgroundColor:
				theme.palette.mode === 'dark' ? '#8796A5' : '#aab4be',
			borderRadius: 20 / 2,
		},
	}));

    const btnSwitchStyles = {
        color: theme.palette.grey[900],
        fontSize: 'max(20px, 1.25vw)',
        position: 'relative',
        textTransform: 'unset',
        fontWeight: 400,
        '&::before':{
            content: '""',
            position: 'absolute',
            top: '100%',
            left: '50%',
            transform: 'translateX(-50%)',
            width: '0',
            height: '3px',
            background: theme.palette.primary.main,
            borderRadius: '3px'
        },
        '&.active':{
            fontWeight: 700,
            '&::before':{
                width: '100%',
            }
        },
        '&:hover':{
            backgroundColor: 'transparent'
        }
    }

	const handleChangeLang = async(e) => {
		const newCurrLang = systemLanguages.find(
			(lang) => +lang.id !== +currentLanguage.id,
		);
		if (!newCurrLang) return; 
		localStorage.setItem('lang', newCurrLang.code);
		setCurrentLanguage(newCurrLang);
		setIsRtl(!isRtl);
        setBasePath(!isRtl ? '/he' : '/en');

		
		if(!cart.id) return;
		await handlingAfterFetch(
			EditCartService({cartId: cart.id, userLangId: newCurrLang.id}),
			(res) => {
				if(res.success && res.data) setCart(res.data);
			},
			setAlertObject
		);
	};

	return (
		<Box sx={{ direction: `${isRtl ? 'ltr' : 'rtl'}` }}>
			<AppBar
				position='fixed'
				className='header-wrapper'
				color='grey'
				sx={header_styles(isTransparent)}
			>
				<Toolbar sx={{paddingRight: '0 !important', paddingLeft: '0 !important'}}>
					<Grid
						container
						className={`justify-between align-start nowrap`}
					>
							<a href={
                                    isTransparent
                                    ? isRtl
                                        ? 'https://www.hevertranslations.co.il/'
                                        : 'https://www.hevertranslations.com/'
                                    : '/'
                                } 
                                target={isTransparent ? '_blank' : '_self'} 
                                className='logo'
                            >
								<img
									src={isRtl ? logo : logo_hever_eng}
									style={{width: isTransparent ? 'max(12.708vw, 100px)' : 'max(7.5vw, 90px)'}}
									alt='Logo'
								/>
							</a>
						<FormGroup
							sx={{
								width: 'max(170px, 15%)',
								flexDirection: 'row',
								alignItems: 'center',
                                justifyContent: 'flex-end',
							}}
						>

							<Button 
                                sx={btnSwitchStyles} 
                                className={currentLanguage.languageName === systemLanguages?.find(
                                            (el) => el.defaultLang === false,
                                )?.languageName ? 'active' : null}
                                onClick={handleChangeLang}
                            >
								{
									systemLanguages?.find(
										(el) => el.defaultLang === false,
									)?.languageName
								}
							</Button>
							<Button 
                                sx={btnSwitchStyles} 
                                className={currentLanguage.languageName === systemLanguages?.find(
                                            (el) => el.defaultLang === true,
                                )?.languageName ? 'active' : null}
                                onClick={handleChangeLang}
                            >
								{
									systemLanguages?.find(
										(el) => el.defaultLang === true,
									)?.languageName
								}
							</Button>
						</FormGroup>
					</Grid>
				</Toolbar>
			</AppBar>
		</Box>
	);
}
export default Header;
